import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Head from 'next/head';
import { getCookie } from '../../../utils/cookies';
import { SettingsContext } from '../../../hoc/Settings';
import { LocalizationContext } from '../../../hoc/Localization';
import styles from './styles.less';
import LoginDialog from '../../loginDialog';

const Login = ({ children, id, onCancel, onLogin, visible }) => {
  const cookieReferral = getCookie('referral');
  const [referral, setReferral] = React.useState(cookieReferral);
  const [showMessage, setShowMessage] = React.useState(false);
  if (referral !== cookieReferral) {
    setReferral(cookieReferral);
  }

  const { t } = React.useContext(LocalizationContext);
  const {
    domainSettings: {
      google: { clientId },
    },
  } = React.useContext(SettingsContext);

  React.useEffect(() => {
    if (window.gapi) {
      window.gapi.load('auth2', () => {
        window.gapi.auth2.init();
      });
    }
  });

  const showModal = e => {
    e.stopPropagation();
    e.preventDefault();
  };

  const hideModal = () => {
    onCancel();
  };

  const childrenWithProps = React.Children.map(children, child =>
    React.cloneElement(child, { onClick: showModal }),
  );

  const checkEmailContent = (
    <>
      <img className={styles.emailImage} src="/static/images/login/email.svg" alt="email" />
      <h3>{t('custom.email.success.message')}</h3>
    </>
  );

  return (
    <>
      <Head>
        <meta name="google-signin-client_id" content={clientId} />
      </Head>
      <Modal
        className={`${styles.containerModal} ${styles.loginModalBackground}`}
        visible={visible}
        onCancel={hideModal}
        footer={[]}
        wrapClassName={styles.loginModal}
      >
        {showMessage ? (
          checkEmailContent
        ) : (
          <LoginDialog onLogin={onLogin} setShowMessage={setShowMessage} />
        )}
      </Modal>

      {id ? (
        <div id={id} className="idPlaceholder">
          {childrenWithProps}
        </div>
      ) : (
        childrenWithProps
      )}
    </>
  );
};

Login.propTypes = {
  id: PropTypes.string,
  children: PropTypes.any,
  onCancel: PropTypes.func,
  visible: PropTypes.bool,
  onLogin: PropTypes.func,
};

Login.defaultProps = {
  id: null,
  children: null,
  onCancel: () => { },
  visible: false,
  onLogin: () => { },
};

export default Login;
